<section class="maintenance-hero">
  <div class="maintenance-bg">
    <div class="ikp-maintenance-guy-bg">
      <header id="header">
        <div class="container-md">
          @if (isHeaderLogoVisible) {
            <div class="row pt-3">
              <div class="col-12">
                <mwe-header-logo />
              </div>
            </div>
          }
          <div class="row maintenance mt-7 h-auto">
            <div class="col-md-6 d-block d-md-none">
              <img class="maintenance-img" src="assets/img/ikp-maintenance-illustration.svg" alt="{{ headline | translate }}" />
            </div>
            <div class="col-md-6 p-4 maintenance-text">
              <h1 [innerHTML]="headline | translate"></h1>
              @if (subheadline) {
                <h2 [innerHTML]="subheadline | translate"></h2>
              }
              <p [innerHTML]="text | translate"></p>
              @if (isBtnVisible) {
                <mwe-button
                  class="d-block mt-7"
                  [showHoverEffect]="true"
                  [labelKey]="buttonLabelkey | translate"
                  (clicked)="onbuttonClick()"
                />
              }
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
</section>
<ikp-footer />
